define(['modules/common/controls/control'], (Control) => Control.extend({

    tagName: 'label',
    className: 'checkbox',

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.input.is(':checked'));
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.input.prop('checked', Boolean(value));
            }
        },
        enabled (view, value) {
            view.input.attr('disabled', !value);
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        },
        text (view, value) {
            view.span.html(_.escape(value));
        }
    },

    render () {
        Control.prototype.render.apply(this, arguments);

        this.input = $('<input>').attr('type', 'checkbox');
        this.span = $('<span>').html(this.options.controlHtml);
        this.$el.empty().append(this.input, this.span);

        if (this.options.inline) {
            this.$el.addClass('inline');
        }

        return this;
    }

}));
